<template>
    <div class="layout-page">
         <h1>Applications In-Progress</h1>   
         <p>
            The following are applications you've chosen to fill out on behalf of your prospects or your downline's prospects. Once these are submitted and approved
            or deleted, they will no longer show on this page.
         </p>
         
         <i class="fas fa-spinner fa-spin ml-orange fa-lg" v-if="loading"></i>
         <div v-else v-cloak>
            <div class="b-card">
               <div class="card-header bg-transparent">
                  <i class="fas fa-user-edit"></i>
                  <span class="card-label">Appointment Applications</span>
               </div>
               <div class="card-body">
                  <div class="font-smaller">
                     <data-grid
                        :headers="headers"
                        :records="records"
                        :rowsPerPage="pageSize"
                        :currentPage="page"
                        :totalRecords="totalRecs"
                        :navHandler="navHandler"
                        :noDataMsg="noDataMsg"
                        @page-size-changed="pageChanged"
                        :clickHandler="gridClickHandler"
                     >
                     </data-grid>
                  </div>
               </div>
            </div>
         </div>
    </div>
</template>

<script>
import DataGrid from "@/components/datagrid.vue";

export default {
   components: {
      "data-grid": DataGrid,
   },
   computed: {
      totalPages() {
         return this.hasData ? Math.trunc(this.totalRecs / this.pageSize) + (this.totalRecs % this.pageSize > 0 ? 1 : 0) : 0
      }
   },
   data() {
      return {
         loading: true,
         records: [],
         pageSize: 10,
         page: 0,
         totalRecs: 0,
         noDataMsg: 'No incomplete applications found.',
         headers: [
            {
               name: "prospect",
               label: "Prospect",
               sortable: true,
               isdate: false,
               ismoney: false,
            },
            {
               name: "recruiter",
               label: "Recruiter",
               sortable: true,
               isdate: false,
               ismoney: false,
            },
            {
               name: "initiatedDt",
               label: "Initiated",
               sortable: true,
               isdate: true,
               ismoney: false,
            },
            {
               name: "status",
               label: "Status",
               sortable: true,
               isdate: false,
               ismoney: false,
            },
            {
               name: "__ACTION",
               label: "Appointment",
               sortable: true,
               isdate: false,
               ismoney: false,
               tt: 'Edit Application'
            }
         ]
      }
   },
   async mounted() {
      await this.initialize();
   },
   methods: {
      async initialize() {
         this.$parent.loadingStart()
         await this.fetchData()
         await this.$nextTick()
         this.$parent.loadingEnd()
      },
      hasData() {
         if (this.records != null) {
               return this.records.length > 0
         }
         return false
      },
      async pageChanged(newCount) {
         this.page = 0
         this.pageSize = parseInt(newCount)
         
         this.$parent.loadingStart()
         await this.fetchData()
         await this.$nextTick()
         this.$parent.loadingEnd()
      },
      async fetchData() {
         this.loading = true
         let payload = {
            submitterId : this.$store.getters.appUser.userId,
            page: this.page,
            pageSize: this.pageSize
         }
         await this.$appoint.viewInProgress(payload)
         .then((r) => {
            if (!r || r == false) {
               this.loading = false
               this.$swal(
                  "Oops!",
                  "Some system error occurred while retrieving in progress appointments. If this problem persists, please contact support.",
                  "error"
               );
               return;
            }

            this.records = r.results
            this.totalRecs = r.totalRecords

            this.records.forEach((rec) => {
               rec.status = rec.status.replace('New Contract', 'Submitted for Approval') 
            })
            this.loading = false
         })
         .catch((err) => {
            this.loading = false
         })
      },
      gridClickHandler(row) {
         if (row) {
            this.$router.push({ name: 'appoint', params: { id: row.appointmentId }})
            return
         }
      },
      async navHandler(command) {
         switch(command) {
               case 'FIRST':
                  this.page = 0
                  break;
               case 'PREVIOUS':
                  this.page--
                  break;
               case 'NEXT':
                  this.page++
                  break;
               case 'LAST':
                  this.page = this.totalPages - 1
                  break;
         }
         this.$parent.loadingStart()
         await this.fetchData()
         await this.$nextTick()
         this.$parent.loadingEnd()
      }
   }
}
</script>

<style scoped>
.card-label {
   margin-left: 6px;
}
</style>